<template>
  <div class="esqueci">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <p class="titulo rosa-padrao-cor">ESQUECI A SENHA</p>
          <form @submit.prevent="onSubmit()">
            <div class="form-group">
              <label for="user">Email</label>
              <input type="email" class="form-control" id="email" v-model="email" placeholder="Email">
              <!-- <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> -->
            </div>
            <button type="submit" class="btn btn-padrao btn-rosa mt-4">Enviar</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.esqueci {
  .titulo {
    font-size: 48px;
    font-weight: 700;
    margin-bottom: 20px;
  }
}

@media (min-width: 992px) {
}
</style>

<script>
export default {
  name: 'EsqueciSenha ',
  data() {
    return {
      email: '',
    }
  },
  components: {
  },
  methods: {
    onSubmit() {
      console.log(this.email)
    }
  }
}
</script>